import React from "react";
import {
  CallToActionButton,
  ContactForm7,
  Cover,
  LandingCover,
  NewsIndex,
  NewsIndexSticky,
  NewsIndexNonSticky,
} from "../components";
import {
  BlockRenderer,
  getClasses,
  getStyles,
} from "@webdeveducation/wp-block-tools";
import { GatsbyImage } from "gatsby-plugin-image";

export const blockRendererComponents = (block) => {
  switch (block.name) {
    case "core/cover":
      // console.log("RENDER COMPONENT: ", block);
      let focalPoints = "center center";
      if (block.attributes.focalPoint) {
        const focalPointX = block.attributes.focalPoint.x + "%";
        const focalPointY = block.attributes.focalPoint.y + "%";
        focalPoints = focalPointX + " " + focalPointY;
      }

      return (
        <Cover
          key={block.id}
          style={getStyles(block)}
          className={getClasses(block)}
          gatsbyImage={block.attributes.gatsbyImage}
          focalPoints={focalPoints}
        >
          <BlockRenderer blocks={block.innerBlocks} />
        </Cover>
      );
    case "core/quote":
      return (
        <blockquote
          key={block.id}
          className="border-l-color-grey-light relative mx-8 mb-8 border-l-4 pl-6 text-lg font-medium leading-6 tracking-widest text-color-tertiary-light"
        >
          <BlockRenderer blocks={block.innerBlocks} />
        </blockquote>
      );
    case "contact-form-7/contact-form-selector": {
      return (
        <ContactForm7 
          key={block.id} 
          formId={block.attributes.id} 
          formMarkup={block.attributes.formMarkup.replace('novalidate="novalidate"',"").split('aria-required="true"').join('aria-required="true" required')} 
        />
      );
      }
    case "core/html":
      const embedCode = block.originalContent;
      return (
        <div
          key={block.id}
          dangerouslySetInnerHTML={{ __html: embedCode }}
          className="mx-auto my-0 h-[1450px] w-[550px]"
        ></div>
      );
    case "core/image":
      return (
        <figure key={block.id} className={getClasses(block)}>
          <GatsbyImage
            style={getStyles(block)}
            image={block.attributes.gatsbyImage}
            alt={block.attributes.alt || ""}
            width={block.attributes.width}
            height={block.attributes.height}
          />
        </figure>
      );
    case "db/newsindex":
      return <NewsIndex key={block.id} />;
    case "db/newsindexnonsticky":
      return <NewsIndexNonSticky key={block.id} />;
    case "db/newsindexsticky":
      return <NewsIndexSticky key={block.id} />;
    case "db/ctabutton":
      const alignMap = {
        left: "text-left",
        center: "text-center",
        right: "text-right",
      };
      return (
        <div key={block.id} className={alignMap[block.attributes.data.align]}>
          <CallToActionButton
            destination={block.attributes.data.destination}
            label={block.attributes.data.label}
          />
        </div>
      );
    case "db/landingcover":
      // return (
      //   <LandingCover 
      //     key={block.id}
      //     headline={block.attributes.data.headline}
      //     slug={block.attributes.data.slug}
      //     label={block.attributes.data.label}
      //     label2={block.attributes.data.label2}
      //     link={block.attributes.data.link}
      //     link2={block.attributes.data.link2}
      //   />
      // );
      return <div key={block.id}>This is the Landing Cover. Make sure to edit WP files to include image.</div>;
    case "db/landinginfo": 
      return (
        <section key={block.id} style={getStyles(block)} className={`${getClasses(block)} info__landing w-full xl:w-3/4 xl:min-w-[1200px] !mx-0 xl:min-h-[27rem] pt-8 pb-10 xl:py-[3.2rem] px-3 sm:pb-[150px] xl:px-[35px] xl:!mx-auto`}>
          <div className="info__landing--wrapper text-color-white flex flex-col xl:flex-row flex-nowrap justify-start items-center xl:max-w-[1200px] xl:mx-auto">
            <div className="info__landing--headline xl:w-1/2 xl:h-fit mb-6 xl:mb-0">
              <h2 className="text-8 xl:text-[3.25rem] font-bold leading-tight xl:leading-none xl:max-w-[25.5rem]">
                {block.attributes.data.headline}
              </h2>
            </div>
            <div className="info__landing--copy xl:w-1/2 xl:h-fit" dangerouslySetInnerHTML={{ __html: block.attributes.data.copy }}></div>
          </div>
        </section>
      );
    case "core/media-text":
      // set content to align middle using flex
      // not set up for l/r alternating right now because of gutters. 
      const content = (
        <div className="flex items-center lg:px-3">
          <div>
            <BlockRenderer blocks={block.innerBlocks}/>
          </div>
        </div>
      );
      // Note on tailwind calc: w-[calc(100%/12*5)] 
      // Note, pass classes to the parent elements so that we can work on inner blocks. Created the class media__landing for the landing page media block
      return (
        <section key={block.id} style={getStyles(block)} className={getClasses(block)}>
          {block.attributes.mediaPosition === "right" && content}
          <div className="landing-hero-image lg:self-center lg:pr-9 w-fit mx-auto">
            <GatsbyImage alt="" image={block.attributes.gatsbyImage} />
          </div>
          {block.attributes.mediaPosition !== "right" && content}
        </section>
      )
    case "db/ctadonate":
      return (
        <section key={block.id} style={getStyles(block)} className={`${getClasses(block)} donate__landing bg-color-tertiary py-[3.2rem] px-[35px] !mb-0 sm:py-[100px] md:p-[100px]`}>
          <div className="donate__landing--wrapper flex flex-nowrap flex-col xl:flex-row justify-start items-center xl:max-w-[1200px] xl:mx-auto xl:min-h-[24rem]">
            <div className="donate__landing--headline xl:w-1/2 h-fit">
              <h2 className="text-color-white text-4xl text-center xl:text-[4.125rem] font-bold uppercase leading-[1.4] xl:text-left mb-9 xl:mb-0">
                {block.attributes.data.headline}
              </h2>
            </div>
            <div className="donate__landing--callToAction xl:w-1/2 xl:h-fit xl:pr-[100px]">
              <p className="!text-color-white text-center text-[1.125rem] font-normal leading-[1.4]">
                {block.attributes.data.slug}
              </p>
              <a className="cta-button !text-color-white uppercase text-center text-[2rem] font-bold w-full border-color-white border-2 border-solid py-1 px-2 rounded-xl inline-block cursor-pointer no-underline transition-colors hover:bg-color-white hover:!text-color-tertiary" href={block.attributes.data.link}>
                  {block.attributes.data.label}
              </a>
            </div>
          </div>
        </section>
      );
    case "core/preformatted":
      return (
        <div className="disclaimer text-center absolute bottom-[100px] left-0 right-0">
          <div key={block.id} style={getStyles(block)} className={`disclaimer--wrapper inline-block text-color-white border-solid border-color-white border-2 px-3 py-2 ${getClasses(block)}`} >
            Paid for by Dan Branda for Westchester
          </div>
        </div>
      );
    default:
      return null;
  }
};
